import { render, staticRenderFns } from "./BeginSigning.vue?vue&type=template&id=61108750"
import script from "./BeginSigning.vue?vue&type=script&lang=js"
export * from "./BeginSigning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports